interface ConfidenceBadgeProps {
  confidence: number;
  label?: string;
}

export function ConfidenceBadge({ confidence, label }: ConfidenceBadgeProps) {
  const color =
    confidence >= 0.8
      ? "text-green-700 bg-green-50 border-green-200"
      : confidence >= 0.5
        ? "text-yellow-700 bg-yellow-50 border-yellow-200"
        : "text-danger-foreground bg-danger border-danger-border";

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium border rounded-full ${color}`}
    >
      {label ?? `${Math.round(confidence * 100)}%`}
    </span>
  );
}
